export const locationConstants = {
    LOCATION_PROCESS_START: 'location:start',
    LOCATION_PROCESS_STOP: 'location:stop',
    LOCATION_LIST: 'location:list',
    LOCATION_ADD: 'location:add',
    LOCATION_UPDATE: 'location:update',
    LOCATION_REMOVE: 'location:delete',
    LOCATION_CLEAR: 'location:clear',
}